module.exports = __webpack_public_path__ + "img/img19.ece41b7b.png";